import { Box, Button, Typography } from '@mui/material'
import Step1Image from 'assets/images/artists/step1.webp'
import Step from 'components/pages/artists/SectionSteps/Step'
import NextImage from 'next/image'

const Step1Left = () => {
  return (
    <Box>
      <NextImage src={Step1Image} alt="step-1" objectFit="cover" />
    </Box>
  )
}

const Step1Right = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '2rem',
        width: '80%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: ' white ',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          Submit the contact Form
        </Typography>
        <Typography variant="bodyLato1" sx={{ color: ' white ' }}>
          Create and manage your own profile easily. Our service is free, we
          don&apos;t believe in subscription or premium features. Since we are
          in BETA phase, there are only a few spots available in each country.
        </Typography>
        <Button
          variant="filled-rounded"
          color="white"
          sx={{ width: 'fit-content', padding: '11.5px 1rem 9.5px 1rem' }}
        >
          Contact form
        </Button>
      </Box>
    </Box>
  )
}

const Step1 = () => {
  return (
    <Box sx={{ height: '100vh' }} id="section-steps">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'space-between',
          padding: '2.5rem 0',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              textAlign: 'center',
              color: ' white',
              fontSize: '3.125rem',
              fontWeight: '700',
            }}
          >
            Join inckd. in 3 simple steps
          </Typography>
        </Box>
      </Box>

      <Step
        stepNum={1}
        left={<Step1Left />}
        right={<Step1Right />}
        fullHeight={false}
      />
    </Box>
  )
}

export default Step1
